import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconMinus$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconMinus extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '07071ac4082ccf7030ee9f42578f2873b872438c', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '8998b5f85e4d3d8181705bf8a5cf33a3c39236a4', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'a17c60412d1d26cb3f331f719ff4776cc9c93a19', d: "M4.5 10.75a.5.5 0 0 1 .5-.5h12a.5.5 0 0 1 .5.5v.5a.5.5 0 0 1-.5.5H5a.5.5 0 0 1-.5-.5z", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-minus", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-minus"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-minus":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconMinus$1);
            }
            break;
    } });
}

const CosmosIconMinus = CosmosIconMinus$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconMinus, defineCustomElement };
